import api from '@/api';

class Report {
  /**
   * @returns {AxiosPromise<any>}
   * @param type
   * @param riskProfile
   * @param complianceTypeId
   * @param tenure
   */
  static get(type, riskProfile, complianceTypeId, tenure) {
    return api.get('/reports', { params: { type, riskProfile , complianceTypeId, tenure } });
  }
}

export default Report;
